<template>
  <div class="goods-item">
    <router-link :to="`/productDetail/${item.id}`" class="pic">
      <img
        :src="item.img"
        :alt="
          `OCM Globe Inc - Asian food wholesale + ${
            item.name
          }, 亚洲食品批发-美国华源食品集团 + ${item.name}`
        "
      />
    </router-link>
    <div class="txt brand" v-if="showBrand">
      <router-link :to="`/productDetail/${item.id}`" :title="item.brand"
        >{{ item.brand }}
      </router-link>
      <router-link :to="`/productDetail/${item.id}`" :title="item.name">{{
        item.name
      }}</router-link>
    </div>
    <div class="txt" v-else>
      <router-link :to="`/productDetail/${item.id}`" :title="item.name">
        <ul>
          <li>SKU: {{ item.sku }}</li>
          <li>UPC: {{ item.upc }}</li>
          <li>{{ item.name }}</li>
          <li>{{ item.sku_box }}</li>
        </ul>
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'goodsItem',
  props: {
    item: [Object],
    showBrand: {
      type: [Boolean],
      default: false
    }
  }
}
</script>

<style scoped lang="scss">
.goods-item {
  .pic {
    display: block;
    padding-top: 100%;
    position: relative;
    overflow: hidden;
    margin-bottom: 8px;
    border-radius: 10px;
    img {
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      object-fit: contain;
      -webkit-transition: all 0.5s;
      -moz-transition: all 0.5s;
      -ms-transition: all 0.5s;
      -o-transition: all 0.5s;
      transition: all 0.5s;
    }
  }
  .pic:hover img {
    -webkit-transform: scale(1.05);
    -moz-transform: scale(1.05);
    -ms-transform: scale(1.05);
    -o-transform: scale(1.05);
    transform: scale(1.05);
  }
  .txt {
    @extend .sub1-18px;
    a + a {
      margin-top: 4px;
    }
    a {
      overflow: hidden;
      display: -webkit-box;
      -webkit-line-clamp: 5;
      -webkit-box-orient: vertical;
      -webkit-transition: all 0.3s;
      -moz-transition: all 0.3s;
      -ms-transition: all 0.3s;
      -o-transition: all 0.3s;
      transition: all 0.3s;
      font-size: 14px;
    }
    a:hover {
      color: $activeColor;
    }
  }
  .txt.brand a {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
@media only screen and (max-width: 767px) {
  .goods-item .txt a {
    font-size: 14px;
    font-weight: normal;
  }
  .goods-item .txt {
    font-size: 14px;
    font-weight: normal;
  }
}
</style>
